import React from 'react'
import './DotSpinner.css'

function DotSpinner() {
  return (
    <span class="loader"></span>
  )
}

export default DotSpinner